export const FitStorageBehavior = (superClass) => class extends superClass {
  constructor() {
    super();
    window.addEventListener('storage', (event) => { this._handleStorageEvent(event); });
    document.addEventListener('fit-storage-save', (event) => { this._handleStorageEvent(event); });
    window.requestIdleCallback(() => { this.loadStorageValue(); });
  }

  loadStorageValue() {
    this._loaded = false;
    this._load();
  }

  saveStorageValue(storageValue) {
    try {
      if (storageValue === null || storageValue === undefined) {
        window.localStorage.removeItem(this.storageName);
      } else {
        window.localStorage.setItem(this.storageName, this.useRawStorageValue ? storageValue : JSON.stringify(storageValue));
      }
      document.dispatchEvent(new CustomEvent('fit-storage-save', { detail: { name: this.storageName, value: storageValue }, bubbles: false, composed: true }));
    } catch (ex) {
      // Happens in Safari incognito mode,
      this.storageErrorMessage = ex.message;
      console.error('localStorage could not be saved. Safari incognito mode?', ex);
    }
  }

  _handleStorageEvent(ev) {
    if (ev.key === this.storageName || (ev.detail && ev.detail.name === this.storageName)) {
      this._load(true);
    }
  }

  _load(externalChange) {
    let value;
    try {
      value = window.localStorage.getItem(this.storageName);
    } catch (ex) {
      this.storageErrorMessage = ex.message;
      console.error('localStorage could not be loaded. Safari incognito mode?', ex);
      return;
    }

    if (value === null) {
      this._loaded = true;
      this._doNotSave = true; // guard for save watchers
      this.storageValue = null;
      this._doNotSave = false;
      this.dispatchEvent(new CustomEvent('fit-storage-load-empty', { detail: externalChange, bubbles: false }));
    } else {
      if (!this.useRawStorageValue) {
        try { // parse value as JSON
          value = JSON.parse(value);
        } catch (x) {
          this.storageErrorMessage = 'Could not parse local storage value';
          console.error('could not parse local storage value', value);
          value = null;
        }
      }
      this._loaded = true;
      this._doNotSave = true;
      this.storageValue = value;
      this._doNotSave = false;
      this.dispatchEvent(new CustomEvent('fit-storage-load', { detail: externalChange, bubbles: false }));
    }
  }
};
